import {Injectable, OnDestroy} from "@angular/core";
import {BaseSandbox} from "../../common/sandboxes/base/base.sandbox.service";
import {Observable} from "rxjs";
import {Toast} from "@stylehaven/components";

@Injectable({ providedIn: 'root' })
export class ToastsSandbox extends BaseSandbox implements OnDestroy {

    public getToasts(): Observable<Toast[]> {
        return this.storeService.getToasts();
    }

    public clearToasts(): void {
        this.storeService.clearToasts();
    }

}
